import { Injectable } from '@angular/core';
import { ModuleName, TimeTrial } from '../../core-data-model';
import { ModuleAccessService } from '../ModuleAccess/ModuleAccess.service';
import { TimeTrialApiConnect } from './TimeTrialApi.connect';

@Injectable({ providedIn: 'root' })
export class TimeTrialService {
    constructor(
        private timeTrialApiConnect: TimeTrialApiConnect,
        private moduleAccess: ModuleAccessService
    ) {}

    async startTimeTrial(
        timeTrial: TimeTrial,
        module?: ModuleName
    ): Promise<TimeTrial> {
        if (module && this.moduleAccess.isPaidAccount(module)) {
            return;
        }
        return await this.timeTrialApiConnect.startTimeTrial(timeTrial);
    }
}
